<template>
  <Layout :meta="dataMeta">
    <div class="detail_berita">
      <div
        class="detail_berita_background kingster-blog-title-wrap  kingster-style-custom kingster-feature-image "
        :style="{
          background: 'url(' + beritaDetail.image + ')',
        }"
        style="background-size: cover !important; background-repeat: no-repeat !important;"
      >
        <div class="kingster-header-transparent-substitute"></div>
        <div class="kingster-blog-title-overlay" style="opacity: 0.01 ;"></div>
        <div class="kingster-blog-title-bottom-overlay"></div>
        <div class="kingster-blog-title-container kingster-container">
          <div
            class="kingster-blog-title-content kingster-item-pdlr"
            style="padding-top: 400px ;padding-bottom: 80px ;"
          >
            <header class="kingster-single-article-head clearfix">
              <div
                class="kingster-single-article-date-wrapper  post-date updated"
              >
                <div class="kingster-single-article-date-day">
                  {{ formattedDateDay(beritaDetail.published_at) }}
                </div>
                <div class="kingster-single-article-date-month">
                  {{ formattedDateMonth(beritaDetail.published_at) }}
                </div>
              </div>
              <div class="kingster-single-article-head-right">
                <h1 class="kingster-single-article-title">
                  {{ beritaDetail.title }}
                </h1>
                <div class="kingster-blog-info-wrapper">
                  <div
                    class="kingster-blog-info kingster-blog-info-font kingster-blog-info-author vcard author post-author "
                  >
                    <span class="kingster-head">By</span
                    ><span class="fn"
                      ><a href="#" title="Posts by John Smith" rel="author">{{
                        beritaDetail.author
                      }}</a></span
                    >
                  </div>
                  <div
                    class="kingster-blog-info kingster-blog-info-font kingster-blog-info-category "
                  >
                    <span class="gdlr-core-sep">{{
                      beritaDetail &&
                        beritaDetail.type &&
                        beritaDetail.type.name
                    }}</span>
                  </div>
                </div>
              </div>
            </header>
          </div>
        </div>
      </div>
      <div class="kingster-breadcrumbs">
        <div class="kingster-breadcrumbs-container kingster-container">
          <div class="kingster-breadcrumbs-item kingster-item-pdlr">
            <span property="itemListElement" typeof="ListItem"
              ><a
                property="item"
                typeof="WebPage"
                title="Go to Kingster."
                href="/"
                class="home"
                ><span property="name">Home</span></a
              >
              <meta property="position" content="1" /> </span
            >&gt;<span property="itemListElement" typeof="ListItem"
              ><a
                property="item"
                typeof="WebPage"
                title="Go to the Blog category archives."
                href="/berita"
                class="taxonomy category"
                ><span property="name">Berita</span></a
              >
              <meta property="position" content="2" /> </span
            >&gt;<span property="itemListElement" typeof="ListItem"
              ><span property="name">{{ beritaDetail.title }}</span>
              <meta property="position" content="3" />
            </span>
          </div>
        </div>
      </div>
      <div class="kingster-content-container kingster-container">
        <div
          class=" kingster-sidebar-wrap clearfix kingster-line-height-0 kingster-sidebar-style-none"
        >
          <div
            class=" kingster-sidebar-center kingster-column-60 kingster-line-height"
          >
            <div class="kingster-content-wrap kingster-item-pdlr clearfix">
              <div class="kingster-content-area">
                <article
                  id="post-1268"
                  class="post-1268 post type-post status-publish format-standard has-post-thumbnail hentry category-blog category-post-format tag-news"
                >
                  <div class="kingster-single-article clearfix">
                    <div class="kingster-single-article-content">
                      <img
                        class="alignnone size-full wp-image-5422"
                        :src="beritaDetail.image"
                        alt=""
                        style="object-fit:cover !importan;"
                        width="1700"
                        height="810"
                      />

                      <span
                        class="gdlr-core-space-shortcode"
                        style="margin-top: 30px ;"
                      ></span>
                      <div v-html="beritaDetail.body"></div>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="gdlr-core-page-builder-body"></div>
      <div class="kingster-bottom-page-builder-container kingster-container">
        <div
          class="kingster-bottom-page-builder-sidebar-wrap kingster-sidebar-style-none"
        >
          <div class="kingster-bottom-page-builder-sidebar-class">
            <div
              class="kingster-bottom-page-builder-content kingster-item-pdlr"
            >
              <div class="clear"></div>
              <div class="kingster-single-author clearfix">
                <div class="kingster-single-author-wrap">
                  <div class="kingster-single-author-content-wrap">
                    <div
                      class="kingster-single-author-caption kingster-info-font"
                    >
                      Penulis
                    </div>
                    <h4 class="kingster-single-author-title">
                      <a href="#" title="Posts by John Smith" rel="author">{{
                        beritaDetail.author
                      }}</a>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import broker from "@/utils/broker";
import moment from "moment";

export default {
  props: ["dataMeta"],
  data() {
    return {
      beritaDetail: {},
      contact: {
        facebook: {},
        twitter: {},
        instagram: {},
        linkedin: {},
        youtube: {},
      },
    };
  },
  dataMetaInfo() {
    return {
      title: `${this.dataMeta.name} - Detail Jurusan`,
      htmlAttrs: {
        lang: "en",
        amp: true,
      },
    };
  },
  async mounted() {
    await this.getDataberitaDetail();
    await this.getSosialMedia();
  },
  methods: {
    async getDataberitaDetail() {
      let url = this.$route.params.id;
      broker.fetch.get(`/webschool/content/${url}`).then((res) => {
        this.beritaDetail = res.data.data;
      });
    },
    async getSosialMedia() {
      await broker.fetch
        .get(
          `/webschool/content?types[]=footer_desc&types[]=social_youtube&types[]=social_facebook&types[]=social_instagram&types[]=social_twitter&types[]=social_linkedin&status=published`
        )
        .then((res) => {
          const data = res.data.data;

          this.contact.facebook = data.find(
            (o) => o.type.name === "social_facebook"
          );
          this.contact.instagram = data.find(
            (o) => o.type.name === "social_instagram"
          );
          this.contact.twitter = data.find(
            (o) => o.type.name === "social_twitter"
          );
          this.contact.linkedin = data.find(
            (o) => o.type.name === "social_linkedin"
          );
          this.contact.youtube = data.find(
            (o) => o.type.name === "social_youtube"
          );
        });
    },
    formattedDateDay(date) {
      moment.locale("id");
      return moment(date).format("DD");
    },
    formattedDateMonth(date) {
      moment.locale("id");
      return moment(date).format("MMM");
    },
  },
  components: {
    Layout: () => import("@/components/template4/Layout"),
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/4-sections/template_four/berita/index.scss";
</style>

<style lang="css">
.detail_berita .detail_berita_background {
  background-size: cover !important;
  background-repeat: no-repeat;
}
@import "../../../../assets/css/template4/style-core.css";
@import "../../../../assets/css/template4/kingster-style-custom.css";
@import "../../../../assets/css/template4/page-builder.css";
@import "../../../../assets/css/template4/style.css";
</style>
